import { createAction } from '@reduxjs/toolkit';

const FETCHING_LEARNING_MATERIAL_LIST = 'FETCHING_LEARNING_MATERIAL_LIST';
const FETCHING_LEARNING_MATERIAL_LIST_V2 = 'FETCHING_LEARNING_MATERIAL_LIST_V2';
const FETCHING_LEARNING_MATERIAL_LIST_SUCCESS =
  'FETCHING_LEARNING_MATERIAL_LIST_SUCCESS';
const FETCHING_LEARNING_MATERIAL_LIST_FAILURE =
  'FETCHING_LEARNING_MATERIAL_LIST_FAILURE';
const CREATE_LEARNING_MATERIAL = 'CREATE_LEARNING_MATERIAL';
const GET_LEARNING_MATERIAL_DETAIL = 'GET_LEARNING_MATERIAL_DETAIL';
const UPDATE_LEARNING_MATERIAL = 'UPDATE_LEARNING_MATERIAL';
const CLEAR_LEARNING_MATERIAL = 'CLEAR_LEARNING_MATERIAL';
const GENERATE_LEARNING_MATERIAL = 'GENERATE_LEARNING_MATERIAL';
const FETCHING_CONTENT_CREATOR_LIST = 'FETCHING_CONTENT_CREATOR_LIST';

export interface learningMaterialListSuccessPayload {
  id?: number;
  block_id_question?: string;
  name_question?: string;
  type_question?: string;
  status: number;
  graded?: boolean;
  username?: string;
  full_name?: string | null;
  submodule_id?: string;
  submodule_name?: string;
}

type learningMaterialDataDetailType = Omit<
  learningMaterialListSuccessPayload,
  'id' | 'status' | 'created_date' | 'updated_date' | 'submodule_name'
>;

export const fetchingLearningMaterialList = createAction(
  FETCHING_LEARNING_MATERIAL_LIST,
  (filters: any) => ({
    payload: filters,
  }),
);
export const fetchingLearningMaterialListV2 = createAction(
  FETCHING_LEARNING_MATERIAL_LIST_V2,
  (filters: any) => ({
    payload: filters,
  }),
);
export const fetchingContentCreatorList = createAction(
  FETCHING_CONTENT_CREATOR_LIST,
  (filters: any) => ({
    payload: filters,
  }),
);
export const fetchingLearningMaterialListSuccess = createAction<
  learningMaterialListSuccessPayload[]
>(FETCHING_LEARNING_MATERIAL_LIST_SUCCESS);

export const fetchingLearningMaterialListFailure = createAction(
  FETCHING_LEARNING_MATERIAL_LIST_FAILURE,
);
export const createLearningMaterial =
  createAction<learningMaterialDataDetailType>(CREATE_LEARNING_MATERIAL);

export const getLearningMaterialDetail = createAction(
  GET_LEARNING_MATERIAL_DETAIL,
  (id: string) => ({
    payload: { id },
  }),
);
export const clearLearningMaterial = createAction(CLEAR_LEARNING_MATERIAL);

export const updateLearningMaterial = createAction(
  UPDATE_LEARNING_MATERIAL,
  (data: learningMaterialDataDetailType, id: string) => ({
    payload: { data, id },
  }),
);

export const generateLearningMaterial = createAction(
  GENERATE_LEARNING_MATERIAL,
  (data: learningMaterialDataDetailType, file_url: string, user: any) => ({
    payload: { data, file_url, user },
  }),
);
